/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";
import PropTypes from "prop-types";

function run(Component, t, i18n, isAuth, language, login, props) {
  let currentPath = props.location.pathname;

  //check if the currentPath is "/"
  if (currentPath === "/") {
    currentPath = "/SelectMission";
  }

  //remove "/" & change to toUpperCase
  currentPath = currentPath.substring(1).toUpperCase().split("/")[0];

  //set language Data
  let languageObj = t(currentPath, { returnObjects: true });

  return (
    <Component
      {...props}
      t={t}
      i18n={i18n}
      isAuth={isAuth}
      language={language}
      login={login}
      languageObj={languageObj}
      RenderFullPageLoading={RenderFullPageLoading}
    />
  );
}

const PublicRoute = ({ component: Component, ...rest }) => (
  <AuthConsumer>
    {({ t, i18n, isAuth, language, login }) => (
      <Route
        render={(props) => run(Component, t, i18n, isAuth, language, login, props)}
        {...rest}
      />
    )}
  </AuthConsumer>
);

PublicRoute.propTypes = {
  component: PropTypes.func,
};

export default PublicRoute;
